import { createClient } from '@launchdarkly/js-client-sdk';

// Initialize LaunchDarkly client
// Replace 'your-client-side-id' with your actual LaunchDarkly client-side ID
const initializeLaunchDarkly = (clientId, user, options) => {

  const ldClient = createClient(clientId, user, options);

  return ldClient;
};

// Export for use in your application
export { initializeLaunchDarkly };

// Auto-initialize if needed
if (typeof window !== 'undefined') {
  window.LaunchDarkly = {
    initialize: initializeLaunchDarkly
  };
}
